import { NoodlesIcon } from './NoodlesIcon';

/**
 * author: Google
 * id 1655675D-A197-44BD-83E9-76E2BAD31740
 * name noodles
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/noodles.svg
 * tags
 * - Food / Drink 
 */
export const AsianNoodlesIcon = NoodlesIcon;
export default AsianNoodlesIcon